import React from "react";
import styles from "./style.module.scss";

interface IProps {
  title?: string;
  rightElement?: JSX.Element;
  children: JSX.Element | JSX.Element[];
}

export default function ContentLayout({title, children, rightElement}: IProps) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>{title}</h1>
        {rightElement}
      </div>
      {children}
    </div>
  );
}
